/**
 * 移除前缀序号文本 
 ```
    console.log(removePrefix('1 标题')); // "标题"
    console.log(removePrefix('1.标题')); // "标题"
    console.log(removePrefix('1. 标题')); // "标题"
    console.log(removePrefix('1.1 标题')); // "标题"
    console.log(removePrefix('1.1.1 标题')); // "标题"

    console.log(removePrefix('1.2024年的财报')); // "2024年的财报"

    console.log(removePrefix('1标题')); // "标题"
    console.log(removePrefix('1.1标题')); // "标题"
    console.log(removePrefix('1.1.1标题')); // "标题"

    console.log(removePrefix('2021年的财报')); // "2021年的财报"
    console.log(removePrefix('标题1.1')); // "标题1.1"
 ```
 */

 export function removePrefix(input: string): string {
  if (/^\d(\.\d)+[^\d]/.test(input)) {
    const result = input.replace(/^\d(\.\d)+/, '');
    return result.trim();
  }
  if (/^(\d\.)+/.test(input)) {
    const result = input.replace(/^(\d\.)+/, '');
    return result.trim();
  }
  if (/^\d[^\d]/.test(input)) {
    const result = input.replace(/^\d/, '');
    return result.trim();
  }
  return input.trim();
}